{
  "main": {
    "title": "Compito di volo",
    "nazaj": "Indietro"
  },
  "labels": {
    "datum": "Data:",
    "pilot": "Seleziona pilota:",
    "reg": "Registrazione dell'aeromobile:",
    "tip": "Tipo di aeromobile:",
    "licenca": "Licenza:",
    "ruta": "Rotta:",
    "namen": "Scopo:",
    "potnik": "Nome e cognome del passeggero:"
  },
  "buttons": {
    "posljiOdobritev": "Invia il compito per approvazione",
    "dodajPotnika": "Aggiungi passeggero",
    "brisiIzbiro": "Cancella selezione"
  },
  "obvestila": {
    "zapisDodan": "Registrazione aggiunta con successo.",
    "napakaVnosa": "Errore di inserimento dati.",
    "napakaInputa": "Alcuni dati obbligatori mancano; controlla e completa il modulo.",
    "napakaBranja": "Errore nella lettura dei dati.",
    "vprasanjeBrisa": "Sei sicuro di voler eliminare il passeggero?",
    "napakaPosiljanja": "Errore di invio",
    "uspesnoPoslan": "Incarico di volo inviato con successo!"
  }
}